import { VIDEO_FILTER_OPTIONS, useVideoFilterStore, type VideoFilterId } from '@features/video-filters';
import { Panel, SelectField, SliderField, SparklesIcon } from '@shared/ui';

/**
 * Panel with the video filter + strength controls that apply to the
 * outgoing stream. Split out of DeviceToolbar so the Preview page can
 * keep camera/mic and filter UX in separate surfaces — the filter
 * clearly belongs to the stream, not to the device list.
 */
export function VideoFilterPanel() {
  const filterSettings = useVideoFilterStore((state) => state.settings);
  const setFilter = useVideoFilterStore((state) => state.setFilter);
  const setIntensity = useVideoFilterStore((state) => state.setIntensity);

  return (
    <Panel title="STREAM FILTER" titleIcon={<SparklesIcon className="h-4 w-4 text-accent" />}>
      <div className="flex flex-wrap items-center gap-6">
        <SelectField
          icon={<SparklesIcon className="h-5 w-5" />}
          label="Filter"
          value={filterSettings.filterId}
          onChange={(event) => setFilter(event.target.value as VideoFilterId)}
          options={VIDEO_FILTER_OPTIONS}
        />

        <div className="min-w-0 flex-1 basis-full sm:basis-auto">
          <SliderField
            label="Strength"
            value={Math.round(filterSettings.intensity * 100)}
            min={0}
            max={100}
            step={5}
            unit="%"
            disabled={filterSettings.filterId === 'none'}
            onChange={(value) => setIntensity(value / 100)}
          />
        </div>
      </div>
    </Panel>
  );
}
